import { useContext } from "react";
import { Grid, IconButton, Typography } from '@material-ui/core';
import { ticketContext } from "../../TicketContext";
import Editable from './Editable'
import ReadOnly from './ReadOnly'
import { UserType } from "helpers/enums";
import { appUserContext } from "helpers/services";
import Moment from "react-moment";
import { Link as RouterLink } from "react-router-dom";
import { EditTicketInformations } from "./EditTicketInformations";
import { Print } from "@material-ui/icons";

let Details = () => {
    let { currentUser } = useContext(appUserContext);
    let { ticket } = useContext(ticketContext);


    return (
        <div style={{ backgroundColor: '#efefef' }}>
            {currentUser?.typology === UserType.VitecUser &&
                <Grid container>
                    <Grid item xs>
                        <Typography variant="subtitle2"><b>Reporter</b></Typography>
                        <Typography variant="body1">{ticket.reporterName}
                            {ticket.reporterCompany && <>&nbsp;&middot;&nbsp;{ticket.reporterCompany}</>}
                            {ticket.reporterM3id && <>&nbsp;&middot;&nbsp;{ticket.reporterM3id}</>}
                        </Typography>
                        <Typography variant="caption">{ticket.reporter}</Typography>
                    </Grid>
                    <Grid item>
                        {currentUser.canWorkOnAllTicket && <EditTicketInformations />}
                        {currentUser.typology === UserType.VitecUser &&
                            <RouterLink target="_blank" to={`/ticket/print/${ticket.id}`}>
                                <IconButton>
                                    <Print />
                                </IconButton>
                            </RouterLink>
                        }
                    </Grid>
                </Grid>
            }

            {ticket.isReadOnly === true && <ReadOnly />}
            {ticket.isReadOnly === false && <Editable />}

            <Grid container>
                {ticket.endCustomersHasRegisteredProduct && (!ticket.registrationId) &&
                    <Grid item xs={12}>
                        {ticket.endCustomerEmailAddress ?
                            <Typography variant="subtitle2" color="secondary"><b>
                                Please choose a Warranty product registration to link to the current Claim
                            </b></Typography>
                            :
                            <Typography variant="subtitle2" color="primary"><b>
                                No end customer email has been provided
                            </b></Typography>
                        }
                    </Grid>
                }
                {ticket.informationsIsMissing &&
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" color="primary">
                            <b>
                                Please fill informations in Request tab
                            </b>
                        </Typography>
                    </Grid>
                }
                {ticket.serialNumberIsMissing &&
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" color="primary">
                            <b>
                                Product has serial number but has not been provided
                            </b>
                        </Typography>
                    </Grid>
                }
                <Grid item xs>
                    <Typography variant="subtitle2"><b>Created By</b></Typography>
                    <Typography variant="body1">{ticket.createdBy}</Typography>
                </Grid>
                <Grid item xs>
                    <Typography variant="subtitle2"><b>Created On</b></Typography>
                    <Typography variant="body1">
                        <Moment date={ticket.createdOn} format="lll" />
                    </Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Typography variant="subtitle2"><b>Last Update By</b></Typography>
                    <Typography variant="body1">{ticket.lastUpdatedBy}</Typography>
                </Grid>
                <Grid item xs>
                    <Typography variant="subtitle2"><b>Last Update On</b></Typography>
                    <Typography variant="body1">
                        <Moment date={ticket.lastUpdatedOn} format="lll" />
                    </Typography>
                </Grid>
            </Grid>
        </div>
    )
}

export default Details;